import React from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth, useTranslator } from '@front-activerse/common-components';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { useAppContext } from '@front-activerse/common-components';

const HeaderSimpleWithMenu = () => {
  const { isAuth } = useAuth();
  const { t } = useTranslator();

  const {
    images: { logo },
    svgInline: { DownArrow },
    navigation: { userNavigationSimple },
  } = useAppContext();

  const [userMenuIsOpen, setUserMenuIsOpen] = useState(false);

  const toggleUserMenu = () => {
    setUserMenuIsOpen(!userMenuIsOpen);
  };
  const fakeToggle = () => {}; //eslint-disable-line

  return (
    <header className="mb-auto main-menu">
      <Navbar light expand="lg" container>
        <NavbarBrand href="/">
          <img src={logo} alt={t('app.default.navbarTitle')} className="img-fluid" />
        </NavbarBrand>

        <NavbarToggler onClick={toggleUserMenu}>
          {t('menu.account')}
          <span className="dropdown-arrow ms-2">
            <span className="SVGInline">
              <DownArrow />
            </span>
          </span>
        </NavbarToggler>

        <Collapse isOpen={userMenuIsOpen} className="user-menu-collapse d-lg-none">
          <Nav navbar>
            {userNavigationSimple.map(
              (item: {
                path?: string;
                translationKey: string;
                disabled?: boolean;
                externalPath?: string;
              }) => {
                if (item.externalPath) {
                  return (
                    <a className="nav-link" href={item.externalPath} key={item.translationKey}>
                      {t(item.translationKey)}
                    </a>
                  );
                }
                return (
                  <NavItem key={item.translationKey}>
                    <NavLink
                      to={item.path || '#'}
                      className={item.disabled ? 'nav-link disabled' : 'nav-link'}
                      onClick={() => toggleUserMenu()}
                    >
                      {t(item.translationKey)}
                    </NavLink>
                  </NavItem>
                );
              }
            )}

            {isAuth ? (
              <NavItem>
                <NavLink to="/auth/logout" className="nav-link" onClick={() => toggleUserMenu()}>
                  {t('menu.logOut')}
                </NavLink>
              </NavItem>
            ) : (
              <NavItem>
                <NavLink to="/auth/login" className="nav-link" onClick={() => toggleUserMenu()}>
                  {t('menu.logIn')}
                </NavLink>
              </NavItem>
            )}
          </Nav>
        </Collapse>

        <div className="d-none d-lg-block">
          <Dropdown isOpen={userMenuIsOpen} toggle={fakeToggle}>
            <DropdownToggle
              tag="span"
              className="dropdown-toggler cursor-pointer"
              onClick={toggleUserMenu}
            >
              {t('menu.account')}
              <span className="dropdown-arrow ms-2">
                <span className="SVGInline">
                  <DownArrow />
                </span>
              </span>
            </DropdownToggle>
            <DropdownMenu end>
              {userNavigationSimple.map(
                (item: {
                  path?: string;
                  translationKey: string;
                  disabled?: boolean;
                  externalPath?: string;
                }) => {
                  if (item.externalPath) {
                    return (
                      <a
                        className="dropdown-item"
                        href={item.externalPath}
                        key={item.translationKey}
                      >
                        {t(item.translationKey)}
                      </a>
                    );
                  }
                  return (
                    <DropdownItem
                      tag={NavLink}
                      to={item.path}
                      key={item.translationKey}
                      onClick={toggleUserMenu}
                      disabled={item.disabled}
                    >
                      {t(item.translationKey)}
                    </DropdownItem>
                  );
                }
              )}

              {isAuth ? (
                <DropdownItem tag={NavLink} to="/auth/logout" key="logout">
                  {t('menu.logOut')}
                </DropdownItem>
              ) : (
                <DropdownItem tag={NavLink} to="/auth/login" key="login">
                  {t('menu.logIn')}
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        </div>
      </Navbar>
    </header>
  );
};

export default HeaderSimpleWithMenu;
